import { PriceInCrypto, PriceInUsd, PriceView } from "@/app/price"
import type { PriceValue } from "@anaconda/core/price/types"
import { reatomComponent } from "@reatom/react"
import { useMolecule } from "bunshi/react"
import { CollectionLeaderboardMoleculeReatom } from "../store.reatom"

interface Props {
  price: PriceValue
}

export const Price = reatomComponent<Props>(({ price }) => {
  const { priceView: priceViewAtom } = useMolecule(
    CollectionLeaderboardMoleculeReatom,
  )
  const priceView = priceViewAtom() // Direct call in reatomComponent

  return priceView === PriceView.USD ? (
    <PriceInUsd className="text-base text-foreground/100" {...price} />
  ) : (
    <PriceInCrypto {...price} />
  )
}, "Price")
